import {Directive, EventEmitter, Input, Optional, Output, TemplateRef} from '@angular/core';
import {ShContextMenuComponent} from './sh-context-menu.component';
import {ShContextMenuClickEvent} from './sh-context-menu.models';
export class MenuItemContext {
  $implicit: any;
constructor() {
    this.$implicit = {};
  }
}

function MenuItemContext_tsickle_Closure_declarations() {
/** @type {?} */
MenuItemContext.prototype.$implicit;
}

export class ShContextMenuItemDirective {
   subMenu: ShContextMenuComponent;
   divider: boolean;
   visible: (event: ShContextMenuClickEvent) => boolean;
   disabled: (event: ShContextMenuClickEvent) => boolean;
   closeOnClick = true;

   click = new EventEmitter<ShContextMenuClickEvent>();

  context: MenuItemContext = new MenuItemContext();
private _active: boolean;
/**
 * @param {?} template
 */
constructor(
public template: TemplateRef<MenuItemContext>) {
  }
/**
 * @return {?}
 */
setNotActive() {
    this._active = false;
    if (this.subMenu) {
      this.subMenu.setNotActive();
    }
  }
/**
 * @return {?}
 */
setActive() {
    this._active = true;
  }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[shContextMenuItem]'
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: TemplateRef, decorators: [{ type: Optional }, ]},
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'subMenu': [{ type: Input },],
'divider': [{ type: Input },],
'visible': [{ type: Input },],
'disabled': [{ type: Input },],
'closeOnClick': [{ type: Input },],
'click': [{ type: Output },],
};
}

function ShContextMenuItemDirective_tsickle_Closure_declarations() {
/** @type {?} */
ShContextMenuItemDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ShContextMenuItemDirective.ctorParameters;
/** @type {?} */
ShContextMenuItemDirective.propDecorators;
/** @type {?} */
ShContextMenuItemDirective.prototype.subMenu;
/** @type {?} */
ShContextMenuItemDirective.prototype.divider;
/** @type {?} */
ShContextMenuItemDirective.prototype.visible;
/** @type {?} */
ShContextMenuItemDirective.prototype.disabled;
/** @type {?} */
ShContextMenuItemDirective.prototype.closeOnClick;
/** @type {?} */
ShContextMenuItemDirective.prototype.click;
/** @type {?} */
ShContextMenuItemDirective.prototype.context;
/** @type {?} */
ShContextMenuItemDirective.prototype._active;
/** @type {?} */
ShContextMenuItemDirective.prototype.template;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
